import React, { PropTypes, Component } from 'react';
import {
  FontIcon,
  FlatButton,
  RaisedButton,
  Popover,
  IconMenu,
  MenuItem,
} from 'material-ui';
import { connect } from 'react-redux';
import {
  goBack as goBackAction,
  push as pushAction,
  replace as replaceAction,
} from 'react-router-redux';
import {
  createNGoToDraft as createNGoToDraftAction,
  clickFinalise as clickFinaliseAction,
  discardDraft as discardDraftAction,
  toggleAssoicatedTemplates as toggleAssoicatedTemplatesAction,
} from './__storeFiles__/actions';
import PolicyNotes from './policyNotes';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import ApplySecondaryIcon from 'material-ui/svg-icons/hardware/device-hub';
import AssociatedTemplateList from './dialogs/associated-template-list';
import injectCss from 'react-jss';
import styles from './styles';
import R from 'ramda';
// import { Link } from 'react-router';
import LoadingOverlay from '../../tc-ui/loading-overlay';
import EditHistories from '../../contracting/generic-components/editHistories';
import { SmallRaisedButton } from '../../tc-ui/small-buttons';
import EditDialog from './dialogs/edit-dialog';
import FinaliseDialog from './dialogs/finalise-dialog';
import pluralize from 'pluralize';
import WaterMark from '../contract-activities-products/watermark';


class SecondaryTemplateRouter extends Component {
  constructor() {
    super();
    this.state = {
      showDraftChangesPopoverOpen: false,
      showDraftChangesPopoverAnchor: null,
      showTemplates: false,
    };
  }

  toggleShowChangesPopover = e =>
    this.setState({
      showDraftChangesPopoverOpen: !this.state.showDraftChangesPopoverOpen,
      showDraftChangesPopoverAnchor: e && e.currentTarget,
    });
  render() {
    const { showDraftChangesPopoverOpen, showDraftChangesPopoverAnchor } = this.state;
    const {
      classes,
      children,
      doc,
      createNGoToDraft,
      discardDraft,
      replace,
      push,
      goBack,
      clickFinalise,
      toggleAssoicatedTemplates,
    } = this.props;
    const {
      type,
      status,
      templateName,
      templates = [],
      isLatest,
      allVersions,
      version,
    } = doc;
    const routerActions = () => {
      const applyToBtn = (
        <FlatButton
          key="applyToBtn"
          label="Apply to Templates"
          backgroundColor={
            window.location.href.indexOf('associate') > -1
              ? 'rgba(0, 0, 0, 0.3)'
              : ''
          }
          hoverColor="rgba(0, 0, 0, 0.15)"
          labelStyle={{ textTransform: 'none' }}
          style={{ color: 'white' }}
          disabled={doc.originFrom === 'initial'}
          onTouchTap={() => replace(`/contracting/master-template/${
            doc.status === 'draft' ? doc.draftId : doc._id
            }/associate?type=${type}`)}
          icon={
            <ApplySecondaryIcon style={{ color: 'white', fontSize: '22px' }} />
          }
        />
      );
      const associatedBtn = (
        <FlatButton
          key="associatedBtn"
          label={`${
            templates.length
            } Associated ${
            pluralize('Template', templates.length)
            }`}
          labelStyle={{ textTransform: 'none', paddingRight: '8px' }}
          hoverColor="rgba(0, 0, 0, 0.15)"
          style={{ color: 'white', minWidth: '68px' }}
          onTouchTap={toggleAssoicatedTemplates}
          icon={
            <TemplateIcon style={{ color: 'white', fontSize: '22px', marginLeft: '8px' }} />
          }
        />
      );
      const clickFinaliseBtn = (
        <RaisedButton
          key="clickFinaliseBtn"
          label="Finalise"
          disabled={R.isEmpty(doc.rawDiffData)}
          secondary
          labelStyle={{ textTransform: 'none', paddingRight: '12px' }}
          style={{ color: 'white', minWidth: '68px', marginLeft: '16px' }}
          onTouchTap={clickFinalise}
        />
      );
      const editBtn = (
        <FlatButton
          key="editBtn"
          label="Edit"
          labelStyle={{ textTransform: 'none', paddingRight: '12px' }}
          hoverColor="rgba(0, 0, 0, 0.15)"
          style={{ color: 'white', minWidth: '68px', marginLeft: '16px' }}
          onTouchTap={() => {
            if (doc.hasDraft) {
              push(`/contracting/master-template/draft:${doc._id}`);
            } else createNGoToDraft();
          }}
          icon={
            <FontIcon
              className="tc-icon-mode_edit"
              style={{ fontSize: '22px', marginLeft: '8px' }}
            />
          }
        />
      );
      const closeBtn = (
        <div
          key="closeBtn"
          className={classes.closeBtn}
          onClick={goBack}
        >
          <FontIcon className="tc-icon-close" style={{ fontSize: '36px', color: '#fff' }} />
        </div>
      );
      if (status === 'draft') {
        return [
          associatedBtn,
          clickFinaliseBtn,
          closeBtn,
        ];
      }
      if (!isLatest) {
        return [
          closeBtn,
        ];
      }
      return [
        applyToBtn,
        associatedBtn,
        editBtn,
        closeBtn,
      ];
    };
    const versionsNode = (allVersions && allVersions.length > 1) ? (
      <IconMenu
        desktop
        style={{ marginLeft: '4px', cursor: 'pointer' }}
        iconButtonElement={
          <SmallRaisedButton
            labelStyle={{
              padding: '0 6px',
              fontSize: '12px',
            }}
            style={{ marginLeft: '8px' }}
            label={`(Version ${version})`}
          />}
      >
        {
          allVersions.map((v, i) => (
            <MenuItem
              key={v}
              disabled={v === doc._id}
              primaryText={`Version ${i + 1}`}
              onTouchTap={() => replace(`/contracting/master-template/${v}`)}
            />))
        }
      </IconMenu>
    ) : ``;
    const { ContentNode, typeLabel } = (() => {
      if (type === 'policyNotes') {
        return {
          ContentNode: PolicyNotes,
          typeLabel: 'Corporate Policies & Notes',
        };
      }
      return {
        ContentNode: 'div',
      };
    })();
    return (
      <div className="full-screen-page">
        <div
          className={classes.topbar}
        >
          <span
            className={classes.topBarTitle}
            onClick={() => push(`/contracting/master-template-list?type=${type}`)}
          >
            {typeLabel} Templates
          </span>
          <span style={{ fontSize: 18 }}>&nbsp;>&nbsp;</span>
          <span
            className={classes.topBarTitle}
            onClick={() => replace(`/contracting/master-template/${doc._id}`)}
          >
            {templateName}
          </span>
          {versionsNode}
        </div>
        <div className={classes.topbarActions}>
          {routerActions()}
        </div>
        <div className={classes.body}>
          {
            !isLatest && !doc.loading && (
              <WaterMark texts={['Old Version', 'Old Version', 'Old Version', 'Old Version']} />
            )
          }
          {(() => {
            if (status === 'draft' && doc.originFrom === 'edited') {
              return (
                <div
                  className={`flex-tc-sb ${classes.subTitle}`}
                >
                  <span>
                    This draft was created from this{' '}
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => replace(`/contracting/master-template/${doc.draftId}`)}
                    >
                      template
                    </a>
                    .
                  </span>
                  <div className="flex-center">
                    <FlatButton
                      secondary
                      label={
                        R.isEmpty(doc.rawDiffData)
                          ? `You haven't made any changes yet.`
                          : 'View Changes'
                      }
                      labelStyle={styles.flatBtnLabelStyle}
                      style={{
                        height: '30px',
                        display: 'block',
                        border: R.isEmpty(doc.rawDiffData) ? 'none' : '1px solid #00bcd4',
                      }}
                      disabled={R.isEmpty(doc.rawDiffData)}
                      onTouchTap={this.toggleShowChangesPopover}
                    />
                    <FlatButton
                      primary
                      label={R.isEmpty(doc.rawDiffData) ? 'Discard Draft' : 'Discard Changes'}
                      labelStyle={styles.flatBtnLabelStyle}
                      style={{ height: '30px', border: '1px solid #ff4081', marginLeft: '8px' }}
                      onTouchTap={discardDraft}
                    />
                  </div>
                </div>
              );
            }
            if (status === 'completed' && doc.hasDraft) {
              return (
                <div
                  className={classes.subTitle}
                >
                  <span>
                    This template has a{' '}
                    <a
                      style={{ cursor: 'pointer' }}
                      onClick={() => replace(`/contracting/master-template/draft:${doc._id}`)}
                    >
                      draft
                    </a>
                    .
                  </span>
                </div>
              );
            }
            return <div />;
          })()}
          <div className={classes.content}>
            {
              children ? children : <ContentNode />
            }
          </div>
        </div>
        <Popover
          open={showDraftChangesPopoverOpen}
          anchorEl={showDraftChangesPopoverAnchor}
          anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.toggleShowChangesPopover}
          style={{ padding: '16px' }}
        >
          <EditHistories
            diffSummary={{
              summaryByPage: doc.rawDiffData,
              ratesSummary: doc.ratesSummary,
            }}
          />
          {
            /*
            * <Link
          to={`/contracting/reports/diff/master-template/${doc.draftId}/draft:${doc.draftId}`}
          style={{ color: '#00b3cf' }}
          >
          View side by side comparison
          </Link>
            * */
          }
        </Popover>
        <LoadingOverlay loading={doc.loading} />
        <EditDialog />
        <FinaliseDialog typeLabel={typeLabel}/>
        <AssociatedTemplateList typeLabel={typeLabel} />
      </div>
    );
  }
}

SecondaryTemplateRouter.propTypes = {
  children: PropTypes.node,
  goBack: PropTypes.func,
  classes: PropTypes.object,
  doc: PropTypes.object,
  createNGoToDraft: PropTypes.func,
  push: PropTypes.func,
  replace: PropTypes.func,
  clickFinalise: PropTypes.func,
  discardDraft: PropTypes.func,
  toggleAssoicatedTemplates: PropTypes.func,
};

const mapStateToProps = ({
  contracting: {
    masterTemplate: { docs },
  },
}) => {
  return {
    doc: docs[docs.currentId] || {},
  };
};

export default connect(
  mapStateToProps,
  {
    goBack: goBackAction,
    push: pushAction,
    createNGoToDraft: createNGoToDraftAction,
    replace: replaceAction,
    clickFinalise: clickFinaliseAction,
    discardDraft: discardDraftAction,
    toggleAssoicatedTemplates: toggleAssoicatedTemplatesAction,
  },
)(injectCss(styles)(SecondaryTemplateRouter));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/router.jsx